import script from "./Contacted.page.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacted.page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QPullToRefresh from 'quasar/src/components/pull-to-refresh/QPullToRefresh.js';
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QPullToRefresh,QPageSticky,QBtn});
